import { render } from "./index.vue?vue&type=template&id=29b4eb22"
import script from "./not-found.ts?vue&type=script&lang=js"
export * from "./not-found.ts?vue&type=script&lang=js"

import "./not-found.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script